<template>
  <div class="max-w-screen-2xl mx-auto px-4 md:px-10">
    <div class="bg-white rounded-xl px-8 md:px-16 py-12 font-light">
      <diamond-detail-clarity-content :clarity="clarity">
        <template #title>
          <base-headline class="!text-2xl mb-6 !normal-case !tracking-normal">
            {{ t("components.diamonds.details.clarity.title") }}:
            {{ Array.isArray(clarity) ? clarity[0] : clarity }}
          </base-headline>
        </template>
      </diamond-detail-clarity-content>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import BaseHeadline from "@/components/baseHeadline.vue";
import DiamondDetailClarityContent from "@/components/diamonds/details/DiamondDetailClarityContent.vue";

const { t } = useI18n();

defineProps<{
  clarity: string | string[];
}>();
</script>

<style></style>
